import { DisconnectedSVG } from "./DisconnectedSVG";
export default DisconnectedSVG;
